import { FC } from 'react';

import { PersonalIdentifierType } from '@/shared/lib/sj-orm';
import { Icon, IconName } from '@/shared/uikit/Icon';

type PidTypeIconProps = {
  type: PersonalIdentifierType;
};

const iconsMap: Record<PersonalIdentifierType, IconName> = {
  [PersonalIdentifierType.CITIZENSHIP_CERTIFICATE]: 'CitizenshipCertificate',
  [PersonalIdentifierType.PASSPORT]: 'Passport',
  [PersonalIdentifierType.NATIONAL_ID]: 'NationalId',
  [PersonalIdentifierType.RESIDENCE_PERMIT]: 'ResidencePermit',
  [PersonalIdentifierType.BIRTH_CERTIFICATE]: 'BirthCertificate',
  [PersonalIdentifierType.TAX_ID]: 'TaxId',
  [PersonalIdentifierType.EDUCATION]: 'EducationCertificate',
  [PersonalIdentifierType.SOCIAL_SECURITY]: 'SocialSecurity',
  [PersonalIdentifierType.MEDICAL_ID]: 'MedicalId',
  [PersonalIdentifierType.DRIVER_LICENSE]: 'DriverLicense',
  [PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE]: 'InternationalDriverPermit',
  [PersonalIdentifierType.MILITARY_ID]: 'MilitaryId',
  [PersonalIdentifierType.FREE_BLOCK]: 'FreeBlock',
  [PersonalIdentifierType.SUBSTANCE]: 'Substance',
};

export const PidTypeIcon: FC<PidTypeIconProps> = ({ type }) => (
  <Icon name={iconsMap[type]} size="s20" />
);
